<template>
	<div class="">
		<router-view></router-view>
	</div>
</template>

<script>

import List from '@/components/productions/List'
import View from '@/components/productions/View'

export default {
	routes: [
		{
			path: "",
			redirect: "/productions/list"
		},
		{
			path: "list",
			components: {
				default: List
			},
			name: "Productions list"
		},
		{
			path: ":channel_id/view/:output_name",
			components: {
				default: View
			},
  			props: {
      			default: true,
      		},
			name: "Productions view"
		}
	
	]
}
</script>